import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import CreateAdDialog from "./CreateAdDialog";
import { useMarketingActions } from "./useMarketing";

export default function CreateAdButton({ connections, defaultConnectionId }) {
  const [open, setOpen] = useState(false);
  const actions = useMarketingActions();

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<Add />}
        disabled={connections.length === 0}
        onClick={() => setOpen(true)}
      >
        Create ad
      </Button>
      {open ? (
        <CreateAdDialog
          connections={connections}
          defaultConnectionId={defaultConnectionId}
          actions={actions}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
}
